// extracted by mini-css-extract-plugin
export default {"spacer":"spacer_spacer__vkBU0","line":"spacer_line__TIkvZ"};